import React from 'react';
import { handleTellMeMore } from '../../../shared/utils/navigationUtils';

export default function UserProfileIntroQuestion({ onSave, onCancel, isLoading = false }) {
  return (
    <>
      <p className="text-muted text-center mb-3">
        Looks like this is your first time here,<br />
        do you want to get an introduction?
      </p>
      <div className="d-grid gap-2 mb-3">
        <button 
          onClick={isLoading ? onSave : () => {
            handleTellMeMore();
            onSave();
          }} 
          className="btn btn-primary d-flex align-items-center justify-content-center" 
          disabled={isLoading}
        >
          {isLoading ? (
            'Creating Profile...'
          ) : (
            <>
              <i className="bi bi-box-arrow-up-right me-2"></i>
              Yes please
            </>
          )}
        </button>
        <button onClick={onCancel} className="btn btn-link text-muted" disabled={isLoading}>
          No thanks
        </button>
      </div>
    </>
  );
}
